import { render, staticRenderFns } from "./upload-idcard.vue?vue&type=template&id=d03bcafe&scoped=true&"
import script from "./upload-idcard.vue?vue&type=script&lang=js&"
export * from "./upload-idcard.vue?vue&type=script&lang=js&"
import style0 from "./upload-idcard.vue?vue&type=style&index=0&id=d03bcafe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03bcafe",
  null
  
)

export default component.exports